import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

const ProtectedRoute = ({ children, requiresOnboarding = false }) => {
  const { user, loading, needsOnboarding } = useAuth()
  const location = useLocation()

  console.log('ProtectedRoute check:', {
    user: !!user,
    loading,
    needsOnboarding,
    requiresOnboarding,
    path: location.pathname
  })

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    )
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Handle onboarding flow
  if (requiresOnboarding) {
    // If user is on onboarding page but doesn't need onboarding, redirect to dashboard
    if (!needsOnboarding) {
      return <Navigate to="/dashboard" replace />
    }
    // User needs onboarding and is on onboarding page - allow access
    return children
  }

  // For all other protected routes
  if (needsOnboarding) {
    // User needs onboarding but is trying to access other pages - redirect to onboarding
    return <Navigate to="/onboarding" replace />
  }

  // User is authenticated and has completed onboarding - allow access
  return children
}

export default ProtectedRoute